export const config = {
    overflowThreshold: {
        default: 5,
    },
};
